
import {
    ApiHandlerDiscreteParameter,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import {
    AddCartLinesApiParameter,
    UpdateCartApiParameter,
} from "@insite/client-framework/Services/CartService";
import { getCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { CartLineModel, CartModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    { order?: CartModel } & HasOnSuccess & HasOnError<string>,
    AddCartLinesApiParameter,
    CartModel,
    { updateCartApiParameter: UpdateCartApiParameter }
>;

export const PopulateAddLineCollectionApiParameter: HandlerType = props => {
    const state = props.getState();
    const order = props.parameter.order ?? getCartState(state, state.pages.savedOrderDetails.cartId).value;
    if (!order) {
        throw new Error("PlaceOrder was called but there was no order");
    }

    const availableLines = order.cartLines!.filter(
        (cartLine: CartLineModel) =>
            cartLine.canAddToCart && (cartLine.availability?.messageType !== 2 || cartLine.canBackOrder),
    ).map(cartLine => {
        const cartLineCopy: CartLineModel = { ...cartLine, properties: { ...cartLine.properties } };
        delete cartLineCopy.properties?.itemDropShip;
        delete cartLineCopy.properties?.itemHazmat;
        return cartLineCopy;
    });

    props.apiParameter = {
        cartId: API_URL_CURRENT_FRAGMENT,
        cartLineCollection: {
            cartLines: availableLines,
        },
    } as AddCartLinesApiParameter;
};